import { Notes, NoteTone } from "@shared/ui";

interface PatientNotesProps {
  notes?: string;
  tone?: NoteTone;
  loading?: boolean;
  patientId: string;
  clinicId: string;
  toneOptions: Array<{
    value: NoteTone;
    label: string;
    description: string;
  }>;
}

function PatientNotes({
  notes = "",
  tone = "default",
  loading = false,
  patientId,
  clinicId,
  toneOptions,
}: PatientNotesProps) {
  return (
    <Notes
      notes={notes}
      tone={tone}
      loading={loading}
      toneOptions={toneOptions}
      config={{
        apiEndpoint: `/api/healthcare-companies/${clinicId}/patients/${patientId}`,
        apiMethod: "PATCH",
        noteField: "core_private_note",
        toneField: "core_private_note_tone",
        queryKeys: [
          ["patientDetails", patientId],
          ["patients"],
        ],
      }}
    />
  );
}

export default PatientNotes;
